import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scoped.css';
import { analytics } from '../../../utils/firebase';
import classNames from '../../../utils/classNames';
import Button from '../Button';
import { logEvent } from 'firebase/analytics';
import IconDelete from '../../icons/IconDelete';

function ButtonFileInput({
  children = null,
  className = '',
  clearErrors = () => {},
  // defaultValue = '',
  deleteFile = () => {},
  disabled = false,
  errors = {},
  eventName = 'button_click',
  eventParams = {},
  extensionAllowed = ['*'],
  handleChangeFile = () => {},
  name = '',
  noBase64 = false,
  onClick = () => {},
  outlined = false,
  setError = () => {},
  sizeValidation = {},
  style = 'default',
  // type = 'submit',
}) {
  const classes = classNames(
    styles['root'],
    outlined ? styles['outlined'] : styles[style],
    className
  );

  const [modFileName, setModFileName] = useState('');

  // For Image
  // const [file, setFile] = useState(defaultValue || {});
  // const [fileBase64, setFileBase64] = useState(defaultValue);

  const fileToBase64 = (val) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(val);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const formatBytes = (bytes, decimals = 0) => {
    if (bytes === 0) return '0';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
  };

  const handleFileSizeValidation = (file, allow) => {
    if (!allow.kbsize) {
      return true;
    } else {
      return formatBytes(file.size) <= allow.kbsize ? true : false;
    }
  };

  const handleValidation = async (e) => {
    const fileValue = e.target.files[0];
    const fileName = e.target.files[0].name;
    const valExtension = fileName.split('.').pop().toLowerCase();
    const validExtension = handleExtensionValidation(
      valExtension,
      extensionAllowed
    );

    if (!validExtension) {
      handleChangeFile(name, '');
      const errObj = {};
      errObj[name] = {
        type: 'manual',
        message: `Ekstensi file harus ${extensionAllowed.join(',')}`,
      };
      setError(errObj);
      return;
    }

    //untuk kalau non image
    // if(validExtension){
    //     handleNamingFile(fileName, valExtension);
    //     clearErrors(name);
    //     setFile(fileValue);
    //     handleChangeFile(name, fileValue);
    // }

    if (!noBase64) {
      const base64File = fileToBase64(fileValue);
      base64File.then(async (res) => {
        const validFileSize = handleFileSizeValidation(
          fileValue,
          sizeValidation
        );

        if (!validFileSize) {
          handleChangeFile(name, '');
          setError(name, {
            type: 'manual',
            message: `Ukuran Maksimal adalah ${String(sizeValidation.kbsize).charAt(0)} MB`,
          });
        } else {
          handleNamingFile(fileName, valExtension);
          clearErrors(name);
          handleChangeFile(name, res);
        }
      });
    } else {
      const validFileSize = fileValue.size < sizeValidation.kbsize;
      if (!validFileSize) {
        handleChangeFile(name, '');
        const errObj = {};
        errObj[name] = {
          type: 'manual',
          message: `Maximal size adalah ${String(sizeValidation.kbsize).charAt(0)} MB`,
        };
        setError(errObj);
      } else {
        handleNamingFile(fileName, valExtension);
        clearErrors(name);
        handleChangeFile(name, fileValue);
      }
    }
  };

  const handleExtensionValidation = (ext, allow) => {
    if (allow[0] === '*') {
      return true;
    }
    return allow.includes(ext) ? true : false;
  };

  const handleNamingFile = (fileName, valExt) => {
    if (fileName.length > 18) {
      setModFileName(`${fileName.slice(0, 14)}...${valExt}`);
    } else {
      setModFileName(fileName);
    }
  };

  const onBtnClick = () => {
    logEvent(analytics, eventName, eventParams);
    onClick();
  };
  const handleDeleteFile = () => {
    deleteFile();
    setModFileName('');
    document.getElementById('file').value = '';
  };

  return (
    <>
      <div className={styles['btn-input-container']}>
        {modFileName && (
          <span style={{ fontSize: '.925rem' }}>{modFileName}</span>
        )}
        <input
          className={classes}
          disabled={disabled}
          hidden
          id="file"
          onChange={(e) => handleValidation(e)}
          onClick={onBtnClick}
          type="file"
        />
        {!modFileName && (
          <label className={classes} htmlFor="file">
            {children}
          </label>
        )}
        {Object.keys(errors).length > 0 ? (
          <div className={styles['btn-container-upload']}>
            <span style={{ color: 'red', marginTop: '1rem' }}>
              {errors.message}
            </span>
          </div>
        ) : null}
        <div />
        {modFileName ? (
          <Button
            className={styles['btn-delete-file']}
            onClick={handleDeleteFile}
            outlined={true}
          >
            <IconDelete/>
            Hapus File
          </Button>
        ) : null}
      </div>
    </>
  );
}

export default ButtonFileInput;

ButtonFileInput.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  clearErrors: PropTypes.func,
  defaultValue: PropTypes.string,
  deleteFile: PropTypes.func,
  disabled: PropTypes.bool,
  errors: PropTypes.object,
  eventName: PropTypes.string,
  eventParams: PropTypes.object,
  extensionAllowed: PropTypes.array,
  handleChangeFile: PropTypes.func,
  name: PropTypes.string,
  noBase64: PropTypes.bool,
  onClick: PropTypes.func,
  outlined: PropTypes.bool,
  setError: PropTypes.func,
  sizeValidation: PropTypes.object,
  style: PropTypes.oneOf(['default', 'danger', 'success']),
  type: PropTypes.string,
};
